module.exports = __webpack_public_path__ + "img/yukari yakumo_sc1.e638c6a0.png";